import { render } from "./Synopsis.vue?vue&type=template&id=677e5e1b&scoped=true"
import script from "./Synopsis.vue?vue&type=script&lang=js"
export * from "./Synopsis.vue?vue&type=script&lang=js"

import "./Synopsis.vue?vue&type=style&index=0&id=677e5e1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677e5e1b"]])

export default __exports__